export enum CellPhone {
    CELL_PHONE_QTD_DIGITS = 11
}